/**
 * validators
 * handles selection modals validation, component logic and messages
 */
import pluralize from 'pluralize';
import { minValue, maxValue } from 'vuelidate/lib/validators';
import { helpers } from 'vuelidate/lib/validators';

// exactVlaue custom rule
const exactValue = (exact) =>
    helpers.withParams({ type: 'exactValue', exact }, (value) => !helpers.req(value) || exact === value);

const validators = {
    data() {
        return {
            alertType: 'info',
        };
    },
    validations() {
        const selectedCount = {};

        if (this.options.selectMin) {
            selectedCount.minValue = minValue(this.options.selectMin);
        }

        if (this.options.selectMax) {
            selectedCount.maxValue = maxValue(this.options.selectMax);
        }

        if (this.options.selectExact) {
            selectedCount.exactValue = this.exactValue(this.options.selectExact);
        }

        return {
            selectedCount,
        };
    },
    computed: {
        alertMessage() {
            let message = '';

            // selection validation messages
            if (this.$v.selectedCount.$error) {
                // Min
                if (this.options.selectMin && !this.$v.selectedCount.minValue) {
                    message = `At least ${pluralize(
                        'item',
                        this.$v.selectedCount.$params.minValue.min,
                        true
                    )} needs to be selected.`;
                }

                // Max
                if (this.options.selectMax && !this.$v.selectedCount.maxValue) {
                    message = `A maximum of ${pluralize(
                        'item',
                        this.$v.selectedCount.$params.maxValue.max,
                        true
                    )} allowed.`;
                }

                // Exact
                if (this.options.selectExact && !this.$v.selectedCount.exactValue) {
                    message = `${pluralize(
                        'item',
                        this.$v.selectedCount.$params.exactValue.exact,
                        true
                    )} must be selected.`;
                }
            } else if (!this.$v.selectedCount.$error && this.selectedCount > 0) {
                // show selected count
                message = `${pluralize('item', this.selectedCount, true)} selected.`;
            }

            return message;
        },
        enableUseSelected() {
            return this.$v.selectedCount.$error;
        },
    },
    methods: {
        exactValue,
    },
};

export default validators;
